import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class DocumentFolder extends DomainObject {
  id;
  name;
  order;
  parentId;
  hasSubfolders;
  subfolders = [];

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      order: observable,
      parentId: observable,
      hasSubfolders: observable,
      subfolders: observable
    });

    this.merge(other);
  }
}

export default DocumentFolder;

